"use strict";
// https://github.com/deliverr/billing-cron/blob/staging/src/promotion/Promotion.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.SellerPromotionStatus = exports.PromotionType = void 0;
// These are deprecated as we have stopped giving seller promotion and trials.
var PromotionType;
(function (PromotionType) {
    PromotionType["STORAGE"] = "storage";
})(PromotionType || (exports.PromotionType = PromotionType = {}));
var SellerPromotionStatus;
(function (SellerPromotionStatus) {
    SellerPromotionStatus["ACTIVE"] = "ACTIVE";
    SellerPromotionStatus["EXPIRED"] = "EXPIRED";
    SellerPromotionStatus["USED"] = "USED";
    SellerPromotionStatus["CANCELLED"] = "CANCELLED";
})(SellerPromotionStatus || (exports.SellerPromotionStatus = SellerPromotionStatus = {}));
//# sourceMappingURL=Promotion.js.map